import { Component } from "react";
import "./DevControls.css";

export interface props {
	paused: boolean;
	menuOpen: boolean;
	hideMenu: () => void;
	activeNotification: {};
	firstTime: boolean;
	playPause: (shouldPause: boolean) => void;
	seekVideo: (goForwards: boolean) => void;
}

export default class DevControls extends Component<props> {
	render() {
		return (
			<div
				className={
					"devcontrols-container" +
					(this.props.firstTime || this.props.activeNotification ? " hide" : "")
				}
			>
				<div className="d-flex">
					<div
						onClick={() => {
							this.props.seekVideo(false);
						}}
						className="mr-1 dev-button scrub-forward d-flex align-items-center justify-content-center"
					>
						<svg
							style={{ transform: "rotate(180deg)" }}
							height="25px"
							width="25px"
							fill="#fff"
							version="1.1"
							x="0px"
							y="0px"
							viewBox="0 0 100 100"
							enableBackground="new 0 0 100 100"
						>
							<polygon
								fill="#fff"
								points="69.51,35.064 43.643,20.134 43.643,42.658 30.49,35.064 4.633,20.134 4.633,49.999 4.633,79.865   30.49,64.928 43.643,57.342 43.643,79.865 69.51,64.928 95.366,49.999 "
							/>
						</svg>
					</div>
					<div
						onClick={() => {
							this.props.playPause(!this.props.paused);
							this.props.hideMenu();
						}}
						className={"dev-button " + (this.props.paused ? "play" : "pause")}
					></div>
					<div
						onClick={() => {
							this.props.seekVideo(true);
						}}
						className="ml-1 dev-button scrub-forward d-flex align-items-center justify-content-center"
					>
						<svg
							height="25px"
							width="25px"
							fill="#fff"
							version="1.1"
							x="0px"
							y="0px"
							viewBox="0 0 100 100"
							enableBackground="new 0 0 100 100"
						>
							<polygon
								fill="#fff"
								points="69.51,35.064 43.643,20.134 43.643,42.658 30.49,35.064 4.633,20.134 4.633,49.999 4.633,79.865   30.49,64.928 43.643,57.342 43.643,79.865 69.51,64.928 95.366,49.999 "
							/>
						</svg>
					</div>
				</div>
			</div>
		);
	}
}
